import React from 'react'
import { Box, Link, Space, TextBody, TextHeading } from '@ally/metronome-ui'
import { useNoSubnav } from '../hooks'

const NoAccounts: React.FC = () => {
  useNoSubnav()
  return (
    <Box textAlign="center">
      <Space my="md">
        <TextHeading tag="h1" size="xl">
          We&apos;ve missed you, and we&apos;re glad you&apos;re back.
        </TextHeading>
      </Space>
      <TextBody tag="p" size="md">
        You can still view your{' '}
        <Link
          to="/profile"
          text="Profile and Settings"
          aria-label="profile and settings"
        />{' '}
        and{' '}
        <Link
          to="/bank/statements-and-forms"
          text="Statements and Tax Forms"
          aria-label="statements and tax forms"
        />{' '}
        for your old accounts.
      </TextBody>
      <TextBody tag="p" size="md">
        If you&apos;d like to open a new account,{' '}
        <Link
          to="/products-and-rates"
          text="Explore Products and Rates"
          aria-label="explore products and rates"
        />
        .
      </TextBody>
    </Box>
  )
}

export default NoAccounts
